module.exports = __webpack_public_path__ + "img/left_tzmb.5d44fc22.svg";